import React from 'react';
import PropTypes from 'prop-types';
import MobileTaskForm from './mobile_task_form';
import taskApi from 'components/tasks/api';

import 'bundles/tasks/index/tasks.scss';

class MobileTaskFormWrapper extends React.Component {
  static propTypes = {
    callListsAccess: PropTypes.bool.isRequired,
    currentDatabaseId: PropTypes.number,
    currentUserId: PropTypes.number.isRequired,
    databaseMembers: PropTypes.array.isRequired,
    defaultAssociatedModels: PropTypes.array,
    hideByProjectSelect: PropTypes.bool,
    hideContactSelect: PropTypes.bool,
    hideProjectSelect: PropTypes.bool,
    hidePropertySelect: PropTypes.bool
  };

  handleSave = (task) => {
    taskApi.addTask(task);
  }

  render() {
    const {
      callListsAccess,
      currentDatabaseId,
      currentUserId,
      defaultAssociatedModels,
      databaseMembers,
      hideByProjectSelect,
      hideContactSelect,
      hideProjectSelect,
      hidePropertySelect
    } = this.props;

    return (
      <div className="tasks-mobile-content">
        <MobileTaskForm
          assigneeOptions={databaseMembers}
          callListsAccess={callListsAccess}
          currentDatabaseId={currentDatabaseId}
          defaultAssociatedModels={defaultAssociatedModels}
          defaultTaskAssignee={databaseMembers.find(member => member.id === currentUserId)}
          hideByProjectSelect={hideByProjectSelect}
          hideContactSelect={hideContactSelect}
          hideProjectSelect={hideProjectSelect}
          hidePropertySelect={hidePropertySelect}
          indexView={false}
          multipleProjects={true}
          onSave={this.handleSave}
        />
      </div>
    );
  }
}

export default MobileTaskFormWrapper;
